"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ACCollection = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var ACCollection = function (props) {
    var _a = props.data, data = _a === void 0 ? [] : _a, _b = props.template, template = _b === void 0 ? null : _b, renderFields = props.renderFields;
    //   console.log(data, template, renderFields);
    if (!Array.isArray(data) || !template) {
        return;
    }
    return ((0, jsx_runtime_1.jsx)("div", { className: props === null || props === void 0 ? void 0 : props.className, children: data.map(function (item) { return renderFields([template], item); }) }));
};
exports.ACCollection = ACCollection;
